import InfiniteMarquee from "vanilla-infinite-marquee";

export function marquee() {
	const marquees = document.querySelectorAll(".marquee");

	if (marquees.length === 0) {
		return;
	}

	marquees.forEach((marquee) => {
		const button = marquee.querySelector(".marquee__control");
		const marqueeList = marquee.querySelector(".marquee__list");

		button.addEventListener("click", (e) => {
			e.preventDefault();
			marquee.classList.toggle("marquee--paused");
			button.classList.toggle("marquee__control--enabled");
			marqueeList.classList.toggle("paused");
		});
	});

	// Calculate the width of all items in marquee
	let marqueeItemsWidth = 0;
	document.querySelectorAll(".marquee__list > span").forEach((item) => {
		marqueeItemsWidth += parseInt(item.offsetWidth, 10);
	});

	const initMarquee = () => {
		const screenWidth = window.innerWidth;

		// Get items to screen width ratio
		const itemsToScreenWidth =
			Math.round(
				(screenWidth / marqueeItemsWidth + Number.EPSILON) * 100,
			) / 100;
		const duplicateCount = Math.ceil(itemsToScreenWidth) + 1;

		let speed;
		const isMobile = screenWidth < 768;
		if (isMobile) {
			speed = 20000 / itemsToScreenWidth;
		} else if (screenWidth < 992) {
			speed = 30000 / itemsToScreenWidth;
		} else {
			speed = 50000 / itemsToScreenWidth;
		}

		new InfiniteMarquee({
			duplicateInnerElements: false,
			element: "#breakingNews .marquee__list",
			breakpointSize: 768,
			speed,
			duplicateCount,
		});
	};

	initMarquee();
}
